// @ts-nocheck
import type { AppProps } from "next/app";
import React from "react";
import MainLayout from "../layouts/MainLayout";
import BlankLayout from "../layouts/BlankLayout";
import ThemeProvider from "../themes/ThemeProvider";
import { createGlobalStyle } from "styled-components";
import dynamic from "next/dynamic";
import Head from "next/head";
import { NextPage } from "next";
import { Toaster } from "react-hot-toast";
import { useEffect } from "react";

const AuthProvider = dynamic(
  () => import("../components/AuthProvider/AuthProvider"),
  { ssr: true }
);
interface Props extends AppProps {
  err: any;
}

const MyApp: NextPage<Props> = (props: Props) => {

  useEffect(() => {
    window.Clipboard = (function(window, document, navigator) {
      var textArea,
          copy;
  
      function isOS() {
          return navigator.userAgent.match(/ipad|iphone/i);
      }
  
      function createTextArea(text:string) {
          textArea = document.createElement('textArea');
          textArea.value = text;
          document.body.appendChild(textArea);
      }
  
      function selectText() {
          var range,
              selection;
  
          if (isOS()) {
              range = document.createRange();
              range.selectNodeContents(textArea);
              selection = window.getSelection();
              selection.removeAllRanges();
              selection.addRange(range);
              textArea.setSelectionRange(0, 999999);
          } else {
              textArea.select();
          }
      }
  
      function copyToClipboard() {        
          document.execCommand('copy');
          document.body.removeChild(textArea);
      }
  
      copy = function(text:string) {
          createTextArea(text);
          selectText();
          copyToClipboard();
      };
  
      return {
          copy: copy
      };
    })(window, document, navigator);
  }, []);
  const { Component, pageProps, err } = props;
  return (
    <>
      <Head>
        <meta
          name="viewport"
          content="width=device-width, viewport-fit=cover, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        />
      </Head>
      <GlobalStyle />
      <ThemeProvider>
        <Toaster />
        <AuthProvider>
          <MainLayout>
            <Component {...pageProps} err={err} />
          </MainLayout>
        </AuthProvider>
      </ThemeProvider>
    </>
  );
};

const GlobalStyle = createGlobalStyle`
a {
  color: inherit;
  text-decoration: none;
}

* {
  box-sizing: border-box;
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none;
}

input, input:before, input:after {
  -webkit-user-select: initial;
  -khtml-user-select: initial;
  -moz-user-select: initial;
  -ms-user-select: initial;
  user-select: initial;
}

#__next {
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
  background-color: #EEEEEE;
  font-size: 14px;
}

body {
  padding: 0;
  margin: 0;
  overflow: hidden;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
`;

export default MyApp;
